<div id="preloader" aria-busy="true"
 aria-label="Loading, please wait."
  role="progressbar"><img class="icon" src="https://raziraz.github.io/codepen/img/bolt.svg">
</div>

<main id="site" role="main">

<app-navbar ></app-navbar>
<router-outlet ></router-outlet>
</main>

